/* eslint-disable no-case-declarations */
import { AppConstants } from "../../types/Constants";
import {
  BeaconActions,
  GET_LATEST_OR_NEARBY_BEACONS,
  GET_BEACONS_COUNT,
  GET_BUSINESS_BEACONS_IN_GROUP,
  GET_INDOOR_BEACONS,
  GET_BUSINESS_BEACONS_IN_GROUP_BY_DATE,
  SET_BEACON_SEARCH_TEXT,
  SET_CATEGORY_FILTER_VALUE,
  GET_USER_DETAILS,
} from "../../types/actions/Beacon.actions";
import { Beacon } from "../../types/models/Beacon";
import { BeaconState } from "../../types/models/BeaconState";
import { IndoorBeacon } from "../../types/models/IndoorBeacon";

const initialSettings: BeaconState = {
  currentBeacons: undefined,
  currentIndoorBeacons: undefined,
  calendarBeacons: undefined,
  filteredCalendarBeacons: undefined,
  totalBeaconCount: 0,
  totalIndoorBeaconCount: 0,
  searchText: null,
  filterCategory: null,
  activeColumns: [0, 1, 2, 3, 4, 5, 6, 7, 8],
};

const BeaconReducer = (state = initialSettings, action: BeaconActions) => {

  switch (action.type) {
    case GET_USER_DETAILS:
      return {
        ...state
      };
    case GET_LATEST_OR_NEARBY_BEACONS:
      const globalBeacons: Beacon[] = [...(action.payload ?? [])];
      addActiveFlagToBeacons(globalBeacons);
      return {
        ...state,
        currentBeacons: globalBeacons,
      };
    case GET_BUSINESS_BEACONS_IN_GROUP:
      const beacons: Beacon[] = [...(action.payload ?? [])];
      addActiveFlagToBeacons(beacons);
      return {
        ...state,
        currentBeacons: beacons,
      };
    case GET_BEACONS_COUNT:
      return {
        ...state,
        totalBeaconCount: action.payload,
      };
    case GET_INDOOR_BEACONS:
      const indoorBeacons: IndoorBeacon[] = [...(action.payload ?? [])];
      return {
        ...state,
        currentIndoorBeacons: indoorBeacons,
      };
    case GET_BUSINESS_BEACONS_IN_GROUP_BY_DATE:
      const calendarBeacons = [...(action.payload ?? [])];
      addActiveFlagToBeacons(calendarBeacons);
      const filteredCalendarBeacons: Beacon[] = getFilteredBeacons(
        calendarBeacons,
        state.filterCategory
      );
      return {
        ...state,
        calendarBeacons: calendarBeacons,
        filteredCalendarBeacons: filteredCalendarBeacons,
      };
    case SET_BEACON_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload,
      };
    case SET_CATEGORY_FILTER_VALUE:
      const newFilteredCalendarBeacons: Beacon[] = getFilteredBeacons(
        state.calendarBeacons ?? [],
        action.payload
      );
      return {
        ...state,
        filterCategory: action.payload,
        filteredCalendarBeacons: newFilteredCalendarBeacons,
      };
    default:
      return state;
  }
};

export default BeaconReducer;

const addActiveFlagToBeacons = (beacons: Beacon[]) => {
  beacons.forEach(beacon => {
    const startTime = new Date(beacon.start_time).getTime();
    const endTime = new Date(beacon.end_time).getTime();
    const currentTime = new Date().getTime();
    if ((currentTime >= startTime && currentTime <= endTime) || (beacon.start_time == null && beacon.end_time == null)) {
      // Set the flag active when current time is in the beacon's time range
      beacon.active = true;
    }
  });
};

const getFilteredBeacons = (beacons: Beacon[], category: string | null) => {

  if (category && category !== AppConstants.AllCategoriesValue) {
    const filteredBeacons: Beacon[] = [];
    beacons.forEach(beacon => {
      if (beacon.category === category) {
        filteredBeacons.push(beacon);
      }
    });
    return filteredBeacons;
  }
  else {
    return beacons;
  }
};
